import React from 'react';
import { Icon } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { NiceBlue, WhiteFour, SunYellow } from '../../styles/Colours';
import { logout } from '../../redux/user/user.actions';
import { device } from '../../styles/Responsive';

const LateralMenu = styled.div`
  position: fixed;
  top: 100px;
  left: 0;
  width: 280px;
  bottom: 0;
  background: ${NiceBlue};

  @media ${device.laptop} {
    width: 220px;
  }

  @media ${device.tablet} {
    top: auto;
    left: 0;
    right: 0;
    width: 100%;
    bottom: 0;
    z-index: 99;
  }
`;

const LateralLine = styled.div`
  position: absolute;
  width: 0;
  top: 0;
  left: 0;
  bottom: 0;
  background: ${SunYellow};
  transition: all 0.2s ease;

  @media ${device.tablet} {
    display: none;
  }
`;

const Item = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  color: ${props => (props.active ? NiceBlue : WhiteFour)};
  background: ${props => (props.active ? WhiteFour : 'transparent')};
  padding: 20px;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.5;
  cursor: pointer;
  justify-content: flex-start;
  align-items: center;

  span {
    color: ${props => (props.active ? NiceBlue : WhiteFour)};
    font-size: 16px;
    font-weight: bold;
    line-height: 1.5;
  }

  ${LateralLine} {
    width: ${props => (props.active ? '4px' : '0')};
  }

  i {
    font-size: 40px;
    margin-right: 20px;
  }

  &:hover {
    background: ${WhiteFour};
    color: ${NiceBlue};

    span {
      color: ${NiceBlue};
    }

    ${LateralLine} {
      width: 4px;
    }
  }

  @media ${device.tablet} {
    width: 14.285%;
    float: left;
    justify-content: center;
    background: transparent;
    span {
      display: none;
    }
    i {
      color: ${props => (props.active ? SunYellow : WhiteFour)};
      font-size: 30px;
      margin-right: 0;
    }

    &:hover {
      background: transparent;
      color: ${SunYellow};
    }
  }
`;

class DashboardMenu extends React.Component {
  navigate = url => {
    const { history } = this.props;
    if(window.location.pathname.indexOf(url)===0){
      if(window.location.pathname.length === url.length)
        window.location.reload();
      else
        history.push(url);
    }
    else
      history.push(url);
  };

  logout = () => {
    const { history, logout } = this.props;
    localStorage.clear();
    // TODO: REMOVE CONNECTION TO SOCKET IO
    logout();
    history.push('/');
  };

  render() {
    const {
      location: { pathname }
    } = this.props;
    return (
      <LateralMenu>
        <Item
          active={pathname.indexOf('/wall') > -1}
          onClick={() => this.navigate('/wall')}
        >
          <LateralLine />
          <Icon type="read" theme="outlined" />
          <span>Wall</span>
        </Item>
        <Item
          active={pathname.indexOf('/groups') > -1}
          onClick={() => this.navigate('/groups')}
        >
          <LateralLine />
          <Icon type="team" theme="outlined" />
          <span>Groups</span>
        </Item>
        <Item
          active={pathname.indexOf('/documents') > -1}
          onClick={() => this.navigate('/documents')}
        >
          <LateralLine />
          <Icon type="solution" />
          <span>Library</span>
        </Item>
        <Item
          active={pathname.indexOf('/messages') > -1}
          onClick={() => this.navigate('/messages')}
        >
          <LateralLine />
          <Icon type="message" theme="outlined" />
          <span>Messages</span>
        </Item>
        <Item
          active={pathname.indexOf('/users') > -1}
          onClick={() => this.navigate('/users')}
        >
          <LateralLine />
          <Icon type="contacts" theme="outlined" />
          <span>Members</span>
        </Item>
        <Item
          active={pathname.indexOf('/profile') > -1}
          onClick={() => this.navigate('/profile')}
        >
          <LateralLine />
          <Icon type="setting" theme="outlined" />
          <span>Edit Profile</span>
        </Item>
        <Item onClick={this.logout}>
          <LateralLine />
          <Icon type="export" theme="outlined" />
          <span>Logout</span>
        </Item>
      </LateralMenu>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user
});

const mapActionToProps = dispatch => bindActionCreators({ logout }, dispatch);

DashboardMenu = connect(
  mapStateToProps,
  mapActionToProps
)(DashboardMenu);

export default withRouter(DashboardMenu);



// WEBPACK FOOTER //
// ./src/components/DashboardMenu/DashboardMenu.js